import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((c) => {
  const t = localStorage.getItem("zc_store_token") || localStorage.getItem("zc_master_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const masterApi = axios.create({ baseURL: API });
masterApi.interceptors.request.use((c) => {
  const t = localStorage.getItem("zc_master_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

const SESSION_ERRORS = ["Session expired", "Invalid session", "Not authenticated"];
const STORE_KEYS = ["zc_store_token", "zc_user", "zc_staff"];
// Expired/invalid session -> PIN screen if the shop login is still valid, else full login. Never a broken page.
const onAuthError = (isMaster) => (e) => {
  const detail = e?.response?.data?.detail;
  const url = e?.config?.url || "";
  if (e?.response?.status === 401 && SESSION_ERRORS.includes(detail) && !url.startsWith("/auth/login")) {
    const masterOk = !isMaster && tokenValid(localStorage.getItem("zc_master_token"));
    const isAdmin = window.location.pathname.startsWith("/admin");
    const keys = masterOk && !isAdmin ? STORE_KEYS : [...STORE_KEYS, "zc_master_token", "zc_account"];
    keys.forEach((k) => localStorage.removeItem(k));
    const dest = isAdmin ? "/admin/stores" : masterOk ? "/staff" : "/auth";
    if (isAdmin) window.location.replace("/admin/stores");
    else if (window.location.pathname !== dest) window.location.replace(dest);
  }
  return Promise.reject(e);
};
api.interceptors.response.use((r) => r, onAuthError(false));
masterApi.interceptors.response.use((r) => r, onAuthError(true));

export function tokenValid(t) {
  if (!t || t.split(".").length !== 3) return false;
  try { return JSON.parse(atob(t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"))).exp * 1000 > Date.now(); } catch { return false; }
}

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x?.msg?.replace(/^Value error, /, "")).filter(Boolean).join("; ") || "Please check the values";
  return typeof d === "string" ? d : e?.message || "Something went wrong";
};
